import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Tabs, Typography } from "antd";
import { ArrowLeftOutlined,} from "@ant-design/icons";
import ItemManageList from "./components/ItemManageList";
import { fetchItemsList } from "./itemManageThunks";
import PackingStructureList from "./PackingStructure/PackingStructureList";
import { useLocation, useNavigate } from "react-router-dom";

const ItemManage = ({ authInfo }) => {
  const { Title } = Typography;
  const dispatch = useDispatch();
  const { itemList } = useSelector((state) => state.itemManage);

  const navigate = useNavigate();
  const handleNavigateToBack = () => {
  navigate("/inventory/dashboard");
  };

  const [activeKey, setActiveKey] = useState("items");
  const location = useLocation();

  useEffect(() => {
    dispatch(fetchItemsList());
  }, [dispatch]);

  useEffect(() => {
  const params = new URLSearchParams(location.search);
  const tab = params.get("tab");
  if (tab) setActiveKey(tab);
  }, [location.search]);

  return (
    <>
    <div
				style={{
				  display: "flex",
				  alignItems: "center",
				  marginBottom: "24px",
				}}
			  >
				<Button
				  type="text"
				  icon={<ArrowLeftOutlined style={{ fontSize: "22px" }} />} // ✅ Scaled to match Title
				  onClick={handleNavigateToBack}
				  style={{
					marginRight: 12,
					padding: 0,
					height: "auto",
					lineHeight: "1",
					color: "#000", // optional, keeps consistent with text color
				  }}
				/>
				<Title level={2} style={{ margin: 0 }}>
				  Items
				</Title>
			  </div>
    <Tabs
      activeKey={activeKey}
      onChange={setActiveKey}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={[
        {
          label: "Items",
          key: "items",
          children: <ItemManageList itemList={itemList} authInfo={authInfo}/>
        },
        {
          label: "Packing Structure",
          key: "packing",
          children: <PackingStructureList/>
        },
      ]}
    />
    </>
  );
};

export default ItemManage;
